import React from 'react';

export const getHighlightedText = (text, higlight) => {
  let parts = text.split(new RegExp(`(${higlight})`, 'gi'));
  return (<span> { parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === higlight.toLowerCase() ? { color: 'red' } : {}}>
      {part}
    </span>)
  } </span>);
};



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/utils.js